export default class CookieConsentObserver {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        window.addEventListener('c24consent', (event) => {
            const c24consent = event.detail.c24consent;
            if (this.addGoogleAnalyticsCondition(c24consent)) {
                this.addGoogleAnalytics();
            }
            this.handleCookieBannerActionForMatomo(event);
        });
    }

    addGoogleAnalyticsCondition(c24consent) {
        return c24consent !== null && typeof c24consent !== 'undefined' && (c24consent).toString().indexOf('a') !== -1 && document.body.innerHTML.search('GoogleAnalyticsObject') === -1 && typeof googleAnalyticsProperties !== 'undefined';
    }

    addGoogleAnalytics() {
        /* eslint-disable */
        const gaScriptNode = document.createElement('script');
        const googleAnalyticsProperties = window.googleAnalyticsProperties;
        const gaScriptContent = document.createTextNode(`${'' +
            "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');" +
            "ga('create', '"}${googleAnalyticsProperties.googleTrackingId}', 'auto');` +
            `ga('set', 'dimension1', '${googleAnalyticsProperties.deviceOutput}');` +
            `ga('set', 'dimension2', '${googleAnalyticsProperties.cpid}');` +
            `ga('set', 'dimension3', '${googleAnalyticsProperties.userType}');` +
            `ga('set', 'anonymizeIp', ${true});` +
            'ga(\'send\', \'pageview\');' +
            '');
        gaScriptNode.appendChild(gaScriptContent);
        document.querySelector('body').appendChild(gaScriptNode);
        /* eslint-enable */
    }

    handleCookieBannerActionForMatomo(e) {
        const isPaqAvailable = typeof window._paq !== 'undefined' && window._paq !== null;
        const isC24consentAvailable = typeof e.detail.c24consent !== 'undefined' && e.detail.c24consent !== null;
        const cantrackMatomoEventCCs = isC24consentAvailable && e.detail.c24consent.indexOf('a') !== -1;

        if (isPaqAvailable && cantrackMatomoEventCCs) {
            window._paq.push(['setCookieConsentGiven']);
        }
    }
}
